import React, { useState } from "react"
import { Link } from "gatsby-plugin-intl";
import { getLinkPrefix } from "../../utils/getLinkPrefix";
import { ListMenuStyled, ListMenuBlockStyled } from "../../styledComponents"

import { useWindowSize } from "../../hooks"
import { FaChevronDown } from "react-icons/fa"

export const ListMenu = ({ categories, intl, country_code }) => {
  const langKey = intl.language;

  const windowSize = useWindowSize()
  const [isActive, toggleActive] = useState(false)
  const [currentItem, setItem] = useState()

  const handleToggle = (target, state) => {
    if (state) {
      toggleActive(state)
    } else {
      target === currentItem ? toggleActive(!isActive) : toggleActive(true)
    }

    setItem(target)
  }

  if (windowSize.width >= 1250) {
    return (
      <ListMenuStyled>
        {categories && categories.length
          ? categories
            .map((item, index) => {
              const singleColumn = index >= 3
              const hasSubcategories = item.subcategories ? Boolean(item.subcategories.length) : false;
              const localize_item = item.localizations.find(item => item.locale === langKey) || item;
              return (
                <div
                  key={item.id}
                  className={`listMenu_item${isActive && currentItem === item.link ? " active" : ""
                    }${hasSubcategories ? " hasSubcategories" : ""}`}
                  onMouseEnter={() => handleToggle(item.link, true)}
                  onMouseLeave={() => handleToggle(item.link, false)}
                >
                  {item.external_link ?
                    <a href={item.link} title={localize_item.Name}>
                      <span>{localize_item.Name}</span>
                      {hasSubcategories ? <FaChevronDown className="fa-chevron-down" /> : ''}
                    </a>
                    :
                    <Link to={getLinkPrefix('categories', `${item.link}`)} language={langKey}>
                      <span>{localize_item.Name}</span>
                      {hasSubcategories ? <FaChevronDown className="fa-chevron-down" /> : ''}
                    </Link>
                  }

                  {hasSubcategories ? (
                    <ListMenuBlockStyled
                      className={`${singleColumn ? " singleColumn" : ""}`}
                    >
                      {item.subcategories
                        .map(menuItem => {
                          const localized_menuItem = menuItem.localizations.find(item => item.locale === langKey) || menuItem;
                          return (
                            // Job Posting menu link
                            <Link
                              className={`blockItem`}
                              key={menuItem.id}
                              to={menuItem.name === 'Job Postings' ? getLinkPrefix('subcategories', `${item.link}`) : getLinkPrefix('subcategories', `${item.link}/${menuItem.link}`)}
                              language={langKey}
                            >
                              <div className="blockItem_title">
                                {localized_menuItem.name}
                              </div>
                              <div className="blockItem_description">
                                {localized_menuItem.description}
                              </div>
                            </Link>
                          )
                        })}
                    </ListMenuBlockStyled>
                  ) : null}
                </div>
              )
            })
          : false}
      </ListMenuStyled>
    )
  } else {
    return (
      <ListMenuStyled>
        {categories && categories.length
          ? categories
            .map(item => {
              const hasSubcategories = item.subcategories ? Boolean(item.subcategories.length) : false;
              const localize_item = item.localizations.find(item => item.locale === langKey) || item;
              return (
                <div
                  key={item.id}
                  className={`listMenu_item ${isActive && currentItem === item.link ? "active" : ""
                    } ${hasSubcategories ? " hasSubcategories" : ""}`}
                  onClick={() => handleToggle(item.link)}
                >
                  {item.external_link ?
                    <a href={item.link} title={localize_item.Name}>
                      <span>{localize_item.Name}</span>
                    </a>
                    :
                    <Link to={getLinkPrefix('categories', `${item.link}`)} language={langKey} >
                      <span>{localize_item.Name}</span>
                    </Link>
                  }

                  {hasSubcategories ? (
                    <ListMenuBlockStyled>
                      {item.subcategories.length
                        ? item.subcategories
                          .map(menuItem => {
                            const localized_menuItem = menuItem.localizations.find(item => item.locale === langKey) || menuItem;
                            return (
                              <Link
                                className="blockItem"
                                key={menuItem.id}
                                to={getLinkPrefix('subcategories', `/${item.link}/${menuItem.link}`)}
                                language={langKey}
                              >
                                <div className="blockItem_title">
                                  {localized_menuItem.name}
                                </div>
                                <div className="blockItem_description">
                                  {localized_menuItem.description}
                                </div>
                              </Link>
                            )
                          })
                        : false}
                    </ListMenuBlockStyled>
                  ) : null}
                </div>
              )
            })
          : false}
      </ListMenuStyled>
    )
  }
}


// const pageQuery = graphql`
//   query MenuQuery {
//     mb {
//       categories: categories(where: {in_browse_resources: true}, sort:"index:asc"){
//         id
//         Name
//         link
//         external_link
//         tag
//         index
//         subcategories {
//           id
//           description
//           name
//           link
//           tag
//           index
//         }
//       }
//     }
//     site {
//       siteMetadata {
//         languages {
//           defaultLangKey
//           langs
//         }
//       }
//     }
//   }
// `

